import * as angular from "angular";

angular
  .module('bringoz.admin.commons')
  .directive('bringozTooltip', bringozTooltip);

function bringozTooltip() {
  return {
    restrict: 'A',
    link: (scope, element, attrs) => {
      attrs.$set('title', `${attrs.bringozTooltipTitle}`);
      attrs.$set('data-bs-toggle', 'tooltip');
      attrs.$set('data-bs-placement', `${attrs.bringozTooltipPlacement}`);
    }
  };
}
